<template>
  <div>
    <p class="text-primary tdes-intro">
      Personaliza la apariencia visual de tus documentos y correos enviados a
      clientes.
    </p>

    <div class="tdes-layout">
      <!-- ── Selector lateral ── -->
      <div class="tdes-selector">
        <button
          type="button"
          class="tdes-item"
          :class="{ 'tdes-item--active': activeSection === 'documents' }"
          @click="activeSection = 'documents'"
        >
          <i class="el-icon-document tdes-item__icon"></i>
          <span class="tdes-item__name">Documentos</span>
          <span class="tdes-item__desc">Facturas, cotizaciones, contratos</span>
        </button>
        <button
          type="button"
          class="tdes-item"
          :class="{ 'tdes-item--active': activeSection === 'emails' }"
          @click="activeSection = 'emails'"
        >
          <i class="el-icon-message tdes-item__icon"></i>
          <span class="tdes-item__name">Correos</span>
          <span class="tdes-item__desc">Logo y colores del correo</span>
        </button>
      </div>

      <!-- ── Panel de contenido ── -->
      <div class="tdes-panel">
        <!-- ── DOCUMENTOS ── -->
        <div v-show="activeSection === 'documents'" class="tdes-panel__content">
          <div class="tdes-panel__header">
            <div>
              <h6 class="tdes-panel__title">Diseño de documentos</h6>
              <span class="tdes-panel__subtitle"
                >Color principal del encabezado y tabla de ítems</span
              >
            </div>
            <ButtonSaveComponent @onSaveClick="handleSaveClick" />
          </div>

          <div class="doc-preview-layout">
            <!-- Controles -->
            <div class="doc-preview-controls">
              <p class="doc-control-label">Color principal</p>
              <ColorPickerComponent
                @getColor="onGetColorDocument"
                part="document__background_color"
                :color.sync="document__background_color.backgroundColor"
              />
              <p class="doc-control-hint">
                Aplica al encabezado y tabla de ítems del documento.
              </p>
            </div>

            <!-- Documento mockup -->
            <div class="doc-mockup-scroll">
              <div class="doc-mockup">
                <!-- ── Top: logo + badge tipo ── -->
                <div class="doc-mockup__top">
                  <div class="doc-mockup__logo-area">
                    <img
                      v-if="userConfig.image"
                      :src="userConfig.image"
                      alt="Logo"
                      class="doc-mockup__logo-img"
                    />
                    <div v-else class="doc-mockup__logo-placeholder">LOGO</div>
                    <div class="doc-mockup__sk-group mt-2">
                      <div
                        class="doc-mockup__sk doc-mockup__sk--lg doc-mockup__sk--bold"
                      ></div>
                      <div class="doc-mockup__sk doc-mockup__sk--md"></div>
                      <div class="doc-mockup__sk doc-mockup__sk--md"></div>
                      <div class="doc-mockup__sk doc-mockup__sk--sm"></div>
                    </div>
                  </div>
                  <div class="doc-mockup__type-area">
                    <div
                      class="doc-mockup__type-badge"
                      :style="document__background_color"
                    >
                      FACTURA
                    </div>
                    <div class="doc-mockup__doc-number">
                      N° 000-000-000000001
                    </div>
                    <div class="doc-mockup__doc-date">
                      Fecha de emisión: 00-00-0000
                    </div>
                  </div>
                </div>

                <div class="doc-mockup__divider"></div>

                <!-- ── Cliente ── -->
                <div class="doc-mockup__client">
                  <p class="doc-mockup__section-label">CLIENTE</p>
                  <div class="doc-mockup__sk-group">
                    <div
                      class="doc-mockup__sk doc-mockup__sk--lg doc-mockup__sk--bold"
                    ></div>
                    <div class="doc-mockup__sk doc-mockup__sk--md"></div>
                    <div class="doc-mockup__sk doc-mockup__sk--md"></div>
                  </div>
                </div>

                <!-- ── Tabla ── -->
                <div class="doc-mockup__table">
                  <div
                    class="doc-mockup__table-header"
                    :style="document__background_color"
                  >
                    <span class="doc-mockup__th doc-mockup__th--xs"
                      >Código</span
                    >
                    <span class="doc-mockup__th doc-mockup__th--wide"
                      >Detalle</span
                    >
                    <span class="doc-mockup__th">Cant.</span>
                    <span class="doc-mockup__th">P. Unit.</span>
                    <span class="doc-mockup__th">Subtotal</span>
                  </div>
                  <div class="doc-mockup__table-row" v-for="i in 2" :key="i">
                    <span class="doc-mockup__td doc-mockup__td--xs">
                      <div class="doc-mockup__sk doc-mockup__sk--xs"></div>
                    </span>
                    <span class="doc-mockup__td doc-mockup__td--wide">
                      <div class="doc-mockup__sk doc-mockup__sk--lg"></div>
                    </span>
                    <span class="doc-mockup__td"
                      ><div class="doc-mockup__sk doc-mockup__sk--xs"></div
                    ></span>
                    <span class="doc-mockup__td"
                      ><div class="doc-mockup__sk doc-mockup__sk--xs"></div
                    ></span>
                    <span class="doc-mockup__td"
                      ><div class="doc-mockup__sk doc-mockup__sk--xs"></div
                    ></span>
                  </div>
                </div>

                <!-- ── Footer: forma de pago + totales ── -->
                <div class="doc-mockup__footer">
                  <div class="doc-mockup__payment">
                    <p class="doc-mockup__section-label">Forma de pago</p>
                    <div class="doc-mockup__sk doc-mockup__sk--md"></div>
                  </div>
                  <div class="doc-mockup__totals">
                    <div class="doc-mockup__total-row">
                      <span class="doc-mockup__total-label"
                        >Subtotal IVA 15%</span
                      >
                      <span class="doc-mockup__total-value">$0.00</span>
                    </div>
                    <div class="doc-mockup__total-row">
                      <span class="doc-mockup__total-label">Subtotal</span>
                      <span class="doc-mockup__total-value">$0.00</span>
                    </div>
                    <div class="doc-mockup__total-row">
                      <span class="doc-mockup__total-label">IVA 15%</span>
                      <span class="doc-mockup__total-value">$0.00</span>
                    </div>
                    <div class="doc-mockup__total-divider"></div>
                    <div
                      class="doc-mockup__total-row doc-mockup__total-row--main"
                    >
                      <span class="doc-mockup__total-label">Total</span>
                      <span class="doc-mockup__total-value">$0.00</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ── CORREOS ── -->
        <div v-show="activeSection === 'emails'" class="tdes-panel__content">
          <div class="tdes-panel__header">
            <div>
              <h6 class="tdes-panel__title">Diseño de correos</h6>
              <span class="tdes-panel__subtitle"
                >Logo y colores del correo enviado a clientes</span
              >
            </div>
            <ButtonSaveComponent @onSaveClick="handleSaveClick" />
          </div>

          <b-row>
            <b-col xs="12" sm="12" md="4">
              <div class="email-controls">
                <div class="email-control-group">
                  <label class="email-control-label"
                    >Logo cabecera del correo</label
                  >
                  <small class="email-control-hint"
                    >Logo de tu empresa por defecto</small
                  >
                  <div class="mt-2">
                    <FileUploadComponent
                      title="Subir Logo"
                      :preview="userConfig.image"
                      @fileBase64="handleFileBase64"
                    />
                  </div>
                </div>

                <div class="email-control-group">
                  <label class="email-control-label">Fondo de cabecera</label>
                  <ColorPickerComponent
                    @getColor="onGetColor"
                    part="background_header"
                    :color.sync="background_header.backgroundColor"
                  />
                </div>

                <div class="email-control-group">
                  <label class="email-control-label">Texto del footer</label>
                  <ColorPickerComponent
                    @getColor="onGetColor"
                    part="color_footer"
                    :color="color_footer.color"
                  />
                </div>

                <div class="email-control-group">
                  <label class="email-control-label"
                    >Fondo del contenedor</label
                  >
                  <ColorPickerComponent
                    :color.sync="background_container.backgroundColor"
                    @getColor="onGetColor"
                    part="background_container"
                  />
                </div>
              </div>
            </b-col>

            <b-col xs="12" sm="12" md="8">
              <div
                class="wrapper__content-template-default"
                style="padding: 2rem;"
                :style="background_container"
              >
                <div
                  class="content-template-default"
                  style="border-radius: 5px; max-width: 500px; display: block; margin: auto; color: #404040; border-radius: 10px 10px 0px 0px;"
                >
                  <div
                    class="template-header"
                    style="text-align: center; padding: 2rem 0; border-radius: 5px 5px 0px 0px;"
                    :style="background_header"
                  >
                    <img
                      :src="userConfig.image"
                      alt="Logo"
                      class="template-logo"
                      v-if="userConfig.image"
                    />
                  </div>
                  <div
                    class="template-body"
                    style="padding: 2rem 4rem; background-color: #ffffff; border-radius: 0px 0px 5px 5px;"
                  >
                    <p>Hola, [nombre]</p>
                    <p>
                      Soy [nombre], representante de [nombre de la empresa].
                      Somos una compañía que se especializa en [oferta primaria]
                      con el fin de [soluciones a problemas de tus clientes].
                    </p>
                    <p>
                      Sabemos que usted se interesa por conocer más acerca de
                      [tema donde compartió su contacto]. Actualmente, hemos
                      ayudado a nuestros clientes para optimizar su rendimiento
                      en ese rubro.
                    </p>
                  </div>
                </div>

                <div
                  class="template-footer"
                  style="display: flex; justify-content: center; flex-direction: column; align-items: center; margin-top: 2rem;"
                  :style="color_footer"
                >
                  <h2 style="font-size: 2rem;"><LogoComponent /></h2>
                  <small style="margin-top: 10px;"
                    >Este correo fue generado por el cliente que obtuvo</small
                  >
                  <small style="margin-top: 5px;"
                    ><strong
                      >Contáctenos | Términos y Condiciones</strong
                    ></small
                  >
                  <small style="margin: 10px 0px; padding-bottom: 10px;"
                    >Todos los derechos Reservados Mydessk</small
                  >
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configService from "../../services/configService";
import ButtonSaveComponent from "../../../components/ButtonSave";
import FileUploadComponent from "../../../components/FileUpload";
import LogoComponent from "@/components/Logo/Logo";
import ColorPickerComponent from "../../../components/ColorPicker";

export default {
  name: "TemplateDesignComponent",
  data: () => ({
    activeSection: "documents",
    userConfig: {},
    document__background_color: { backgroundColor: "#0e0051 !important" },
    color_footer: { color: "#0e0051" },
    background_header: { backgroundColor: "#FFF" },
    background_container: { backgroundColor: "#F2F3F4" }
  }),
  methods: {
    async load() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const businessId = this.$store.getters.getUser?.user_business?.id;
        const res = await configService
          .getUserConfigEmail(businessId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        if (res.data.data) this.applyData(res.data.data);
      } catch (e) {
        return false;
      }
    },
    async handleSaveClick() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const businessId = this.$store.getters.getUser?.user_business?.id;
        const res = await configService
          .updateUserConfigEmail(this.userConfig, businessId)
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        const { success, message, data } = res.data;
        if (success) {
          if (data) this.applyData(data);
          this.$notifications.success({ message });
        }
      } catch (e) {
        return false;
      }
    },
    onGetColor({ color, part }) {
      if (part === "color_footer") this.color_footer.color = color;
      else this[part].backgroundColor = color;
      this.userConfig[part] = color;
    },
    onGetColorDocument({ color, part }) {
      this[part].backgroundColor = `${color} !important`;
      this.userConfig[part] = color;
    },
    handleFileBase64(base64) {
      this.userConfig.image = base64;
    },
    applyData(data) {
      this.userConfig = data;
      if (data.document__background_color)
        this.document__background_color.backgroundColor =
          data.document__background_color;
      if (data.background_header)
        this.background_header.backgroundColor = data.background_header;
      if (data.background_container)
        this.background_container.backgroundColor = data.background_container;
      if (data.color_footer) this.color_footer.color = data.color_footer;
    }
  },
  components: {
    ButtonSaveComponent,
    FileUploadComponent,
    LogoComponent,
    ColorPickerComponent
  },
  mounted() {
    this.load();
  }
};
</script>

<style scoped lang="scss">
$primary: #31355c;
$secondary: #3ecfb4;
$border: #e4eaf6;
$bg: #f8f9fc;
$muted: #909399;
$white: #fff;

.tdes-intro {
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
}

// ── Layout: sidebar izquierdo + panel derecho ──
.tdes-layout {
  display: grid;
  grid-template-columns: 190px 1fr;
  gap: 20px;
  align-items: flex-start;

  // En tablet/mobile: selector pasa a ser fila horizontal arriba
  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
}

// ── Selector lateral (desktop) ──
.tdes-selector {
  border: 1px solid $border;
  border-radius: 10px;
  overflow: hidden;
  background: $white;

  // En mobile se convierte en fila horizontal de pills
  @media (max-width: 860px) {
    display: flex;
    border-radius: 8px;
    overflow-x: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.tdes-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  width: 100%;
  padding: 14px 16px;
  background: $white;
  border: none;
  border-bottom: 1px solid $border;
  cursor: pointer;
  text-align: left;
  transition: background 0.12s;

  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: $bg;
  }

  &--active {
    background: lighten($secondary, 35%);
    border-left: 3px solid $secondary;
    .tdes-item__name {
      color: $primary;
      font-weight: 700;
    }
    .tdes-item__icon {
      color: $secondary;
    }
  }

  // En mobile: horizontal, sin border-left
  @media (max-width: 860px) {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    width: auto;
    flex-shrink: 0;
    padding: 10px 16px;
    border-bottom: none;
    border-right: 1px solid $border;

    &:last-child {
      border-right: none;
    }
    &--active {
      border-left: none;
      border-bottom: 2px solid $secondary;
    }
    .tdes-item__desc {
      display: none;
    }
  }
}

.tdes-item__icon {
  font-size: 16px;
  color: $muted;
  margin-bottom: 2px;
  @media (max-width: 860px) {
    margin-bottom: 0;
    font-size: 14px;
  }
}

.tdes-item__name {
  font-size: 13px;
  color: $primary;
  font-weight: 500;
  line-height: 1.3;
}

.tdes-item__desc {
  font-size: 11px;
  color: $muted;
  line-height: 1.3;
}

// ── Panel ──
.tdes-panel {
  border: 1px solid $border;
  border-radius: 10px;
  background: $white;
  overflow: hidden;
  min-width: 0; // evita overflow en grid
}

.tdes-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid $border;
  background: $bg;
  gap: 12px;
  margin-bottom: 20px;
}

.tdes-panel__title {
  font-size: 15px;
  font-weight: 700;
  color: $primary;
  margin: 0 0 2px;
}

.tdes-panel__subtitle {
  font-size: 12px;
  color: $muted;
}

.tdes-panel__content {
  padding: 20px;
}

// ── Documentos: controles (izq) + mockup (der) ──
.doc-preview-layout {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.doc-preview-controls {
  flex-shrink: 0;
  width: 150px;
}

.doc-control-label {
  font-size: 11px;
  font-weight: 700;
  color: $primary;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin: 0 0 8px;
}

.doc-control-hint {
  font-size: 11px;
  color: $muted;
  line-height: 1.5;
  margin: 10px 0 0;
}

// En mobile: controles arriba, mockup abajo con scroll horizontal
@media (max-width: 860px) {
  .doc-preview-layout {
    flex-direction: column;
  }
  .doc-preview-controls {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    .doc-control-hint {
      margin: 0;
    }
  }
}

// ── Mockup contenedor ──
.doc-mockup-scroll {
  flex: 1;
  min-width: 0;

  @media (max-width: 860px) {
    width: 100%;
  }
}

// ── Mockup ──
.doc-mockup {
  background: $white;
  border: 1px solid $border;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(49, 53, 92, 0.07);

  // Mobile: escala proporcional con zoom
  @media (max-width: 860px) {
    zoom: 0.62;
    transform-origin: top left;
  }

  @media (max-width: 480px) {
    zoom: 0.52;
  }
}

// ── Top: logo izq + badge tipo der ──
.doc-mockup__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 24px 16px;
  gap: 16px;
}

.doc-mockup__logo-area {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.doc-mockup__logo-img {
  max-height: 44px;
  max-width: 130px;
  object-fit: contain;
}

.doc-mockup__logo-placeholder {
  font-size: 12px;
  font-weight: 800;
  color: $muted;
  letter-spacing: 2px;
  padding: 6px 10px;
  border: 1px dashed $border;
  border-radius: 4px;
}

.doc-mockup__type-area {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.doc-mockup__type-badge {
  display: inline-block;
  padding: 5px 14px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 800;
  color: $white;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.doc-mockup__doc-number {
  font-size: 13px;
  font-weight: 700;
  color: $primary;
}

.doc-mockup__doc-date {
  font-size: 11px;
  color: $muted;
}

// ── Línea divisora ──
.doc-mockup__divider {
  height: 1px;
  background: $border;
  margin: 0 24px;
}

// ── Cliente ──
.doc-mockup__client {
  padding: 12px 24px 14px;
  border-bottom: 1px solid $border;
}

.doc-mockup__section-label {
  font-size: 10px;
  font-weight: 700;
  color: $muted;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin: 0 0 8px;
}

// ── Skeleton lines ──
.doc-mockup__sk-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  &.mt-2 {
    margin-top: 10px;
  }
}

.doc-mockup__sk {
  height: 7px;
  background: darken($bg, 3%);
  border-radius: 3px;
  &--xs {
    width: 32px;
  }
  &--sm {
    width: 60px;
  }
  &--md {
    width: 90px;
  }
  &--lg {
    width: 130px;
  }
  &--bold {
    height: 9px;
    background: darken($bg, 7%);
  }
}

// ── Tabla ──
.doc-mockup__table {
  border-bottom: 1px solid $border;
}

.doc-mockup__table-header {
  display: flex;
  padding: 8px 24px;
}

.doc-mockup__th {
  flex: 1;
  font-size: 10px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  &--xs {
    flex: 0.6;
  }
  &--wide {
    flex: 3;
  }
}

.doc-mockup__table-row {
  display: flex;
  padding: 9px 24px;
  border-top: 1px solid $border;
  &:nth-child(even) {
    background: $bg;
  }
}

.doc-mockup__td {
  flex: 1;
  display: flex;
  align-items: center;
  &--xs {
    flex: 0.6;
  }
  &--wide {
    flex: 3;
  }
}

// ── Footer: pago izq + totales der ──
.doc-mockup__footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 14px 24px;
  gap: 16px;
}

.doc-mockup__payment {
  padding-top: 2px;
}

.doc-mockup__totals {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 180px;
}

.doc-mockup__total-row {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  padding: 2px 0;
}

.doc-mockup__total-divider {
  height: 1px;
  background: $border;
  margin: 4px 0;
}

.doc-mockup__total-row--main {
  .doc-mockup__total-label,
  .doc-mockup__total-value {
    color: $primary !important;
    font-weight: 700;
    font-size: 13px;
  }
}

.doc-mockup__total-label {
  font-size: 11px;
  color: $muted;
  font-weight: 500;
}

.doc-mockup__total-value {
  font-size: 11px;
  color: $primary;
  font-weight: 600;
}

// ── Correos: controles ──
.email-controls {
  display: flex;
  flex-direction: column;
}

.email-control-group {
  padding: 14px 0;
  border-bottom: 1px solid $border;
  &:last-of-type {
    border-bottom: none;
  }
}

.email-control-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: $primary;
  margin-bottom: 3px;
}

.email-control-hint {
  font-size: 11px;
  color: $muted;
}

.content-template-default {
  margin-bottom: 2rem;
}

.template-logo {
  max-width: 100%;
  width: 300px;
  height: auto;
  display: block;
  margin: 0 auto;
}
</style>
